import { createFileRoute } from '@tanstack/react-router';
import AuditLogTable from '@/components/features/compliance/components/audit-log-table';

export const Route = createFileRoute('/_authenticated/compliance/audit-log')({
  component: AuditLogTable,
});
